/** Shared responsive layout for split-pane edit screens (subject, client, project). */
export const editSplitLayoutSx = {
  display: "grid",
  gap: { xs: 2, md: 3 },
  gridTemplateColumns: {
    xs: "1fr",
    md: "1fr",
    lg: "minmax(520px, 62%) minmax(340px, 38%)",
  },
  alignItems: "start",
  mb: 4,
  width: "100%",
  maxWidth: "100%",
};

export const editFormPaperSx = {
  p: { xs: 2, sm: 2.5, md: 2.5 },
  borderRadius: 3,
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
};

export const editPrimaryColumnSx = {
  ...editFormPaperSx,
  p: { xs: 2, sm: 2.5, md: 3 },
};

export const editSideColumnSx = {
  display: "grid",
  gap: { xs: 2, md: 3 },
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
};

export const editSplitWrapperSx = {
  ...editSplitLayoutSx,
};

/** Project edit: two-column split from md+ with viewport-height scroll panes (original layout). */
export const editSplitLayoutProjectSx = {
  display: "grid",
  gap: { xs: 2, md: 3 },
  gridTemplateColumns: {
    xs: "1fr",
    md: "minmax(520px, 62%) minmax(360px, 38%)",
  },
  alignItems: "start",
  mb: 4,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  height: { xs: "auto", md: "calc(100vh - 250px)" },
  overflow: { xs: "visible", md: "hidden" },
};

export const editPrimaryColumnProjectSx = {
  ...editPrimaryColumnSx,
  height: { xs: "auto", md: "100%" },
  minWidth: 0,
  overflowY: { xs: "visible", md: "auto" },
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": { display: "none" },
};

export const editSideColumnProjectSx = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: 2, md: 3 },
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  height: { xs: "auto", md: "100%" },
  overflowY: { xs: "visible", md: "auto" },
  pr: { md: 0.5 },
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": { display: "none" },
};

export const editActionRowSx = {
  mt: 3,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: { xs: "stretch", sm: "flex-end" },
  gap: 2,
  "& .MuiButton-root": {
    flex: { xs: "1 1 auto", sm: "0 0 auto" },
    minWidth: { xs: "120px", sm: "auto" },
  },
};
